import Vue from 'vue';
import LowVersionModal from './low-version-modal.vue';

let instance;

function openLowVersionModal(props = {}) {
  // 如果已存在实例，先销毁
  if (instance) {
    instance.$destroy();
    document.body.removeChild(instance.$el);
    instance = null;
  }

  // 创建组件构造器
  const ModalConstructor = Vue.extend(LowVersionModal);

  const { confirm, ...otherProps } = props;

  // 实例化组件
  instance = new ModalConstructor({
    propsData: {
      ...otherProps,
      show: true,
    },
  });

  // 监听确认事件
  instance.$on('confirm', () => {
    if (confirm) {
      confirm();
    }
  });

  // 监听关闭事件
  instance.$on('close', () => {
    instance.visible = false;
    setTimeout(() => {
      instance.$destroy();
      document.body.removeChild(instance.$el);
      instance = null;
    });
  });

  // 挂载到 DOM
  instance.$mount();
  document.body.appendChild(instance.$el);

  return instance;
}

export default openLowVersionModal;
